import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface DataLifecycleHandler {
	readonly checkedOut$: Observable<void>;
	readonly checkedIn$: Observable<void>;
	readonly discarded$: Observable<void>;
}

export const DATA_LIFECYCLE_HANDLER = new InjectionToken<DataLifecycleHandler>(
	'DATA_LIFECYCLE_HANDLER'
);
